export default __webpack_public_path__ + "static/media/telephone.f8255809.svg";